// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2oyd-","amount":"Amount_amount__25yHx","tip":"Amount_tip__2iL-S","tipHeader":"Amount_tipHeader__2JjZD","tipsWrap":"Amount_tipsWrap__1zH9R"};